import React, { ReactElement, useEffect } from 'react';
import { ImageCustom } from '../../common/components/ImageCustom';
import { AuthState, useAuth } from '../auth/AuthProvider';
import { BlockGroup } from './components/BlockGroup/BlockGroup';
import chargeDiamondIcon from '../../assets/svg/charge2.svg';
import './TopPage.scss';
import { useDispatch } from 'react-redux';
import { showLoginModal } from '../login/login.slice';
import { showRegisterModal } from '../register/register.slice';
import { LiveFollowerList } from '../live-follower-list/LiveFollowerList';
import { LiverLeague, LiverLeagueLevel } from './models/liverLeague';
import { useHistory } from 'react-router';

export const TopPage = (): ReactElement => {
  const { isAuthenticated, isRegistering } = useAuth() as AuthState;
  const dispatch = useDispatch();
  const history = useHistory();
  const leaguesData: LiverLeague[] = [
    {
      name: '注目',
      type: 'attention',
      level: LiverLeagueLevel.OFFICIAL,
      link: '/list/hot',
    },
  ];

  useEffect((): void => {
    // show login modal when user not login
    if (!isAuthenticated && !isRegistering) {
      history.push('/login');
      dispatch(showLoginModal(true));
    }

    if (!isAuthenticated && isRegistering) {
      history.push('/login');
      dispatch(
        showRegisterModal({
          visible: true,
        }),
      );
    }
  }, [isAuthenticated, isRegistering]);

  // setup title
  useEffect(() => {
    document.title = 'Web版everylive（エブリライブ）';
  }, []);

  if (!isAuthenticated) {
    return <></>;
  }

  return (
    <div className="top-page-container">
      {/* <Carousel></Carousel> */}

      <div className="live-top-container">
        <div className="live-top-container__follower-list">
          <LiveFollowerList></LiveFollowerList>
        </div>

        <div className="live-top-container__live-list">
          {leaguesData?.map((league, index) => (
            <BlockGroup key={index} league={league}></BlockGroup>
          ))}
        </div>
      </div>

      <ImageCustom
        className="top-page__charge-button"
        src={chargeDiamondIcon}
        onClick={() => {
          window.open(process.env.REACT_APP_CHARGE_URL);
        }}
      ></ImageCustom>
    </div>
  );
};
